import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ParticipantHeader = _resolveComponent("ParticipantHeader")!
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_SingleErrorMessage = _resolveComponent("SingleErrorMessage")!
  const _component_ValidationAlert = _resolveComponent("ValidationAlert")!
  const _component_DocumentList = _resolveComponent("DocumentList")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_DocumentGenerator = _resolveComponent("DocumentGenerator")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.headerData && !_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_ParticipantHeader, {
          key: 0,
          data: _ctx.headerData
        }, null, 8, ["data"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PageHeader, {
      headerText: `Phase ${_ctx.phaseNumber ?? ''} Documents`
    }, null, 8, ["headerText"]),
    (_ctx.isLoading && !_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_SingleErrorMessage, { errorMessage: _ctx.errorMessage }, null, 8, ["errorMessage"]),
    _createVNode(_component_ValidationAlert, { validationResults: _ctx.validationMessages }, null, 8, ["validationResults"]),
    (!_ctx.isLoading && !_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_v_card, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.phaseId != null)
                  ? (_openBlock(), _createBlock(_component_DocumentList, {
                      key: _ctx.refreshKey,
                      parentId: _ctx.phaseId,
                      parentTypeId: _ctx.parentTypeId,
                      canUpload: _ctx.canUpload,
                      canDelete: _ctx.canDelete
                    }, null, 8, ["parentId", "parentTypeId", "canUpload", "canDelete"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && !_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_v_card, { key: 3 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", null, "Generate Documents from Templates", -1)
              ]))]),
              _: 1
            }),
            (_ctx.phaseId != null)
              ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DocumentGenerator, {
                      documentParentId: _ctx.phaseId!,
                      documentParentTypeId: _ctx.DocumentParentType.Phase,
                      infillProp: _ctx.infillVars,
                      treatmentProgramId: _ctx.caseData.treatmentProgramId,
                      onNewDocumentGenerated: _ctx.refreshDocuments
                    }, null, 8, ["documentParentId", "documentParentTypeId", "infillProp", "treatmentProgramId", "onNewDocumentGenerated"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}